import { observer } from "mobx-react";
import React, { Component } from "react";
import NumericInput from "Components/Common/numericInput";
import 'Styles/OtherSettings/SetMaxFileSizeModal.scss';
import { ShowAlert } from "Utils/CommonFunctions";

class SetMaxFileSizeModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="set-maxfilesize-modal">
                Данная операция запустит процесс пересинхронизации файлов с учетом ограничения по размеру. Процесс может занять продолжительное время и активно использует ресурсы сервера. Рекомендуется выполнять операцию в нерабочее время. Запустить пересинхронизацию?
                <br />
                <div className="set-maxfilesize-modal-input">
                    <span className="set-maxfilesize-modal-input-title">
                        Не загружать файлы больше (Мб):
                    </span>
                    <NumericInput
                        minValue={0}
                        maxValue={10000000}
                        setValue={val => this.props.setMaxFileSize(val)}
                        getValue={() => this.props.getMaxFileSize()}
                        onResetToDefaultMax={() => ShowAlert('error', `Установлено максимальное значение (Мб).`)}
                    />
                </div>
            </div>
        )
    }
}

export default observer(SetMaxFileSizeModal);